import React, { Component } from 'react'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { setMonthOpen } from '../datesSelectorUtil'
import moment from 'moment'
import './mobileDatesSelector.sass'
import { Button, Modal } from '../../../elements'
import { DayPickerRangeController } from 'react-dates'

class MobileDatesSelector extends Component {
  constructor(props) {
    super(props)
    this.mobileFilterRef = React.createRef()
    this.state = {
      loading: true,
      startDate: this.props.startDate ? moment(this.props.startDate) : null,
      endDate: this.props.endDate ? moment(this.props.endDate) : null,
      focusedInput: 'startDate',
      showMobileDates: this.props.forceOpen,
      forceOpened: this.props.forceOpen,
      initialMonth: () =>
        setMonthOpen(
          moment(),
          this.props.endDate ? moment(this.props.endDate) : null,
          'startDate'
        ),
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.forceOpen && !prevState.forceOpened) {
      return {
        showMobileDates: nextProps.forceOpen,
        forceOpened: true,
      }
    }
    return null
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.startDate !== prevProps.startDate ||
      this.props.endDate !== prevProps.endDate
    ) {
      this.setState({
        startDate: this.props.startDate ? moment(this.props.startDate) : null,
        endDate: this.props.endDate ? moment(this.props.endDate) : null,
      })
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('mobile-dates-open')
  }

  displayMobileDatesButtonText = () => {
    if (this.state.startDate == null || this.state.endDate == null) {
      return 'Select Dates'
    } else {
      return (
        <span className="has-black-dark-text">
          {moment(this.state.startDate).format('MMM DD')}{' '}
          <i className="fal fa-arrow-right"></i>{' '}
          {moment(this.state.endDate).format('MMM DD')}{' '}
        </span>
      )
    }
  }

  displayMobileDatesArrowText = () => {
    let startDateText = 'Start Date'
    let endDateText = ' End Date'

    if (this.state.startDate || this.state.endDate) {
      startDateText = moment(this.state.startDate).isValid()
        ? moment(this.state.startDate).format('MMM DD')
        : 'Start Date'

      endDateText = moment(this.state.endDate).isValid()
        ? moment(this.state.endDate).format('MMM DD')
        : 'End Date'
    }

    return (
      <div className="mobile-dates-text">
        <span>{startDateText}</span>
        <span>
          <i className="fal fa-arrow-right"></i>
        </span>
        <span>{endDateText}</span>
      </div>
    )
  }

  clearDates = () => {
    this.setState({
      startDate: null,
      endDate: null,
    })
    this.props.onDatesChange(null, null)
    this.props.onFocusChange(null)
    this.props.onClearDates()
    this.setState({ focusedInput: 'startDate' })
  }

  onDatesChange = (startDate, endDate) => {
    this.setState({ startDate, endDate })

    if (startDate && endDate) {
      this.closeMobileDates()
    }

    this.props.onDatesChange(startDate, endDate)

    this.props.onClose(startDate, endDate)
  }

  onFocusChange = (focusedInput) => {
    this.setState({
      focusedInput: !focusedInput ? 'startDate' : focusedInput,
    })
    this.props.onFocusChange(focusedInput)
  }

  closeMobileDates = () => {
    this.setState({ showMobileDates: false })

    document.body.classList.remove('mobile-dates-open')
  }

  openMobileDates = (e) => {
    e.preventDefault()
    this.setState({ showMobileDates: true })

    document.body.classList.add('mobile-dates-open')
  }

  render() {
    const { showMobileDates, focusedInput, startDate, endDate } = this.state
    const hasDangerBorder =
      this.props.showDateWarning && (!startDate || !endDate)

    return (
      <React.Fragment>
        {this.props.selectorType === 'button' && (
          <Button
            fullwidth
            type="button"
            size="medium"
            onClick={(e) => this.openMobileDates(e)}
            className={hasDangerBorder ? 'danger-border' : ''}
          >
            <span className="icon">
              <i className="fal fa-calendar"></i>
            </span>
            <span>{this.displayMobileDatesButtonText()}</span>
          </Button>
        )}
        {this.props.selectorType === 'arrowFluid' && (
          <Button
            fullwidth
            type="button"
            size="medium"
            className="mobile-dates-button-trigger has-black-dark-text"
            onClick={(e) => this.openMobileDates(e)}
          >
            {this.displayMobileDatesArrowText()}
          </Button>
        )}
        {this.props.selectorType === 'inputWIcons' && (
          <div className="mobile-date-input-w-icon-wrap">
            <div className="mobile-date-input-w-icon">
              <Button
                color="white"
                className="date-w-icon-button"
                size="medium"
                fullwidth
                onClick={(e) => this.openMobileDates(e)}
              >
                {!this.state.startDate && (
                  <>
                    <span className="icon empty-date">
                      <i className="fal fa-calendar-alt"></i>
                    </span>
                    <span className="empty-date">Start Date</span>
                  </>
                )}

                {this.state.startDate && (
                  <>
                    <span className="icon">
                      <i className="fal fa-calendar-alt"></i>
                    </span>
                    <span>{moment(this.state.startDate).format('MMM DD')}</span>
                  </>
                )}
              </Button>
            </div>
            <div className="mobile-date-input-w-icon">
              <Button
                color="white"
                className="date-w-icon-button"
                size="medium"
                fullwidth
                onClick={(e) => this.openMobileDates(e)}
              >
                {!this.state.endDate && (
                  <>
                    <span className="icon empty-date">
                      <i className="fal fa-calendar-alt"></i>
                    </span>
                    <span className="empty-date">End Date</span>
                  </>
                )}
                {this.state.endDate && (
                  <>
                    <span className="icon">
                      <i className="fal fa-calendar-alt"></i>
                    </span>
                    <span>{moment(this.state.endDate).format('MMM DD')}</span>
                  </>
                )}
              </Button>
            </div>
          </div>
        )}

        <Modal
          show={showMobileDates}
          id={this.props.wrapID}
          closeOnBlur={true}
          closeOnEsc={true}
        >
          <div className="mobile-dates-wrap-inner">
            <div className="level is-mobile mb-0 py-3">
              <div className="level-left">
                <div className="level-item">
                  <Button
                    type="button"
                    color="white"
                    onClick={() => this.closeMobileDates()}
                  >
                    <span className="icon is-normal">
                      <i className="far fa-angle-left"></i>
                    </span>
                    <span>Back</span>
                  </Button>
                </div>
              </div>

              <div className="level-right">
                <Button
                  type="button"
                  color="white"
                  onClick={() => this.clearDates()}
                >
                  Clear Dates
                </Button>
              </div>
            </div>

            <DayPickerRangeController
              onDatesChange={({ startDate, endDate }) =>
                this.onDatesChange(startDate, endDate)
              }
              onFocusChange={(focusedInput) => this.onFocusChange(focusedInput)}
              focusedInput={focusedInput}
              startDate={startDate}
              endDate={endDate}
              readOnly={true}
              orientation="verticalScrollable"
              numberOfMonths={6}
              navPrev={false}
              focused={true}
              initialVisibleMonth={this.state.initialMonth}
              hideKeyboardShortcutsPanel
              minimumNights={0}
              {...this.props.additionalDateProps}
              //keepOpenOnDateSelect
            />
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default MobileDatesSelector

MobileDatesSelector.defaultProps = {
  onDatesChange: function() {},
  onFocusChange: function() {},
  startDate: null,
  endDate: null,
  selectorType: 'button', //this can be button, home, or arrowFluid
  additionalDateProps: {},
  onClose: function() {},
  forceOpen: false,
  onClearDates: function() {},
  wrapID: 'mobile-dates-container',
  showDateWarning: true,
}
